module.exports = __webpack_public_path__ + "static/img/pay-unionpay.d60e4f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/plane/pay-unionpay.png
// module id = 0G4+
// module chunks = 4